document.addEventListener('DOMContentLoaded', () => {
  const elements = document.querySelectorAll('.js-parallax');

  if (!elements.length) return;

  const update = () => {
    elements.forEach((el) => {
      const rect = el.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      const progress = 1 - rect.bottom / (viewportHeight + rect.height);
      const img = el.querySelector('img');

      if (img) {
        const range = rect.height * 0.3;
        const translate = (progress - 0.5) * range;
        img.style.transform = `translateY(${translate}px)`;
      }
    });
  };

  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update, { passive: true });
  update();
});
